import { InventoryItemProduct } from '@absg/api-inventory';

export class InventoryItemProductLot implements InventoryItemProduct {
  expirationDate?: Date;
  invItemProductIdentifierId?: number;
  lotNumber?: string;
  lotQuantity?: number;
  lotQuantityUnderhood?: number;
  serialNumber?: string;
  inventoryItemId?: number;
  inventoryUOM?: string;
  dispenseUnitOfMeasureConversionFactor?: number;
  inventoryUnitOfMeasureConversionFactor?: number;
  lotQuantityString?: string;

  // for audit
  unsavedPositionLotQuantity?: number;
  unsavedUnderHoodLotQuantity?: number;
  unsavedLotExpirationDate?: string;
  isAudited?: boolean;
  originalLotTotalDispenseQuantity?: number;
  originalLotTotalInventoryQuantity?: number;
  unsavedLotNumber?: string;
  isNewlyAddedLot?: boolean;
  elementIdString?: string;
  constructor() { }
}
